import { Badge } from '@/components/ui/badge';
import { AlertCircle, Target, CalendarCheck } from 'lucide-react';

export type DeadlineType = 'hard_deadline' | 'flexible_date';

interface DeadlineTypeBadgeProps {
  type: DeadlineType;
  showIcon?: boolean;
  className?: string;
}

export function DeadlineTypeBadge({ type, showIcon = true, className }: DeadlineTypeBadgeProps) {
  const config = {
    hard_deadline: {
      label: 'Hard Deadline',
      className: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
      icon: AlertCircle,
    },
    flexible_date: {
      label: 'Standard Deadline',
      className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
      icon: CalendarCheck,
    },
  };

  const { label, className: badgeClassName, icon: Icon } = config[type] || config.flexible_date;

  return (
    <Badge className={`${badgeClassName} ${className || ''}`}>
      {showIcon && <Icon className="h-3 w-3 mr-1" />}
      {label}
    </Badge>
  );
}

export function getDeadlineTypeDescription(type: DeadlineType): string {
  const descriptions = {
    hard_deadline: 'Delivery must occur on or before the specified date. No late deliveries accepted. Typical for events, grand openings, regulatory deadlines, and contract obligations.',
    flexible_date: 'Some flexibility in delivery timing may exist, subject to client approval.',
  };

  return descriptions[type] || descriptions.flexible_date;
}
